import { render, staticRenderFns } from "./common-new-grid.vue?vue&type=template&id=c6957702&scoped=true"
import script from "./common-new-grid.vue?vue&type=script&lang=js"
export * from "./common-new-grid.vue?vue&type=script&lang=js"
import style0 from "./common-new-grid.vue?vue&type=style&index=0&id=c6957702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6957702",
  null
  
)

export default component.exports